import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import CartButtonComponent from "./components/CartButton/CartButtonComponent";
import CartSummaryDataComponent from "./CartSummaryDataComponent";
import CartItemsComponent from "./components/CartItems/CartItemsComponent";
import {getCart} from "../../services/Cart/reducer";
import CartCashbackComponent from "./CartCashbackComponent";
import CartVouchers from "./components/CartVouchers";
import CartSubmitInfoComponent from "./CartSubmitInfoComponent";
import CartButtonInfoComponent from "./components/CartButton/CartButtonInfoComponent";
import {getSession} from "../../services/Session/reducer";

interface OwnProps {
    goToCart?: () => void;
    showVouchers?: boolean;
    stickySummary?: boolean;
    placement: "MENU" | "CART";
    menuId: number | undefined;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartStickyComponent = (props: Props) => {
    const cartCashbackComponentClassName = props.cart.items.length > 0 ? "mb-3" : "";

    const showCartSubmitInfoComponent = () => {
        if (props.placement === "CART") return true;

        return props.session.order_type !== "DELIVERY";
    };

    const withoutHeader = props.placement === "CART";

    return (
        <div className="cart-sticky sticky-fixed  sticky-fixed-cart fixed-height-100">
            <div className={"cart-sticky-container"}>
                {!withoutHeader && (
                    <div className="cart-sticky-header">
                        <CartButtonInfoComponent menuId={props.menuId}/>
                    </div>
                )}
                <div className={"cart-sticky-body position-relative"}>
                    <CartItemsComponent/>
                    {!props.stickySummary && <CartCashbackComponent className={cartCashbackComponentClassName}/>}
                    {props.cart.items.length > 0 && !props.stickySummary && <CartSummaryDataComponent/>}
                </div>
                <div className={"cart-sticky-footer"}>
                    {props.showVouchers && <CartVouchers/>}
                    {props.goToCart !== undefined &&
                        <CartButtonComponent goToCart={props.goToCart} menuId={props.menuId}/>}
                    {props.stickySummary && <CartCashbackComponent className={cartCashbackComponentClassName}/>}
                    {props.stickySummary && props.cart.items.length > 0 && <CartSummaryDataComponent/>}
                    {showCartSubmitInfoComponent() && (
                        <CartSubmitInfoComponent/>
                    )}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart),
    session: getSession(state.session),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartStickyComponent));